import { parseIds } from '../../utils/offerIdValidation'

/** Numeryczne ID oferty Allegro (np. 18635301649) — nie EAN/GTIN (8 lub 13 cyfr). */
export function isAllegroOfferId(id: string): boolean {
  const trimmed = id.trim()
  if (!/^\d+$/.test(trimmed)) return false
  const len = trimmed.length
  if (len === 8 || len === 13) return false
  return len >= 10 && len <= 12
}

export function filterAllegroOfferIds(ids: string[]): string[] {
  return [...new Set(ids.map((id) => id.trim()).filter(isAllegroOfferId))]
}

export function parseOfferIdsFilter(value: string): string[] {
  return filterAllegroOfferIds(parseIds(value))
}

export function formatOfferIdsFilter(ids: string[]): string {
  return filterAllegroOfferIds(ids).join('\n')
}

export function allegroOfferIdsFromOffers(offers: Array<{ id: string }>): string[] {
  return filterAllegroOfferIds(offers.map((offer) => offer.id))
}
